import * as React from 'react'

import { InfoIcon } from 'lucide-react'
import { v4 as uuidv4 } from 'uuid'

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '~/client/src/shared/components/shadcn-ui/tooltip'

interface IProps {
  label: string
  children: React.ReactNode
}

export default function InfoHint({
  label,
  children,
}: IProps): React.ReactElement {
  const [descriptionId] = React.useState(() => `info-hint-${uuidv4()}`)

  return (
    <Tooltip>
      <TooltipTrigger
        type="button"
        aria-label={label}
        aria-describedby={descriptionId}
        className="tw:flex tw:items-center tw:border-0 tw:bg-transparent tw:p-0 tw:text-muted-foreground tw:cursor-default"
      >
        <InfoIcon className="tw:size-4" />
      </TooltipTrigger>
      <span id={descriptionId} className="tw:sr-only">
        {children}
      </span>
      <TooltipContent>{children}</TooltipContent>
    </Tooltip>
  )
}
